import type { CustomSEOPage } from '@iheartjane/data-access';
import type { Nullish } from '@iheartjane/types';

import { createMetaItem } from './createMetaVariables';

export function description(desc?: string) {
  if (!desc) return {};
  return {
    content: desc,
    name: 'description',
  };
}

export function getMetaDescription(
  customSEOPage?: Nullish<CustomSEOPage>,
  metaVariables: Record<string, string> = {}
) {
  return description(createMetaItem(customSEOPage?.description, metaVariables));
}
